import { ref } from 'vue'

import useEventListener from '@nicolaudie-group/ng-ui-kit/composables/useEventListener'

function useServiceWorker() {
  let registration
  let removeListener
  let reloading = false

  const updateAvailable = ref(false)

  function setUpdateAvailble(event) {
    updateAvailable.value = true
    registration = event.detail
    if (removeListener) {
      removeListener()
    }
  }

  function update() {
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (updateAvailable.value && registration && registration.waiting) {
      // Send message to SW to skip the waiting and activate the new SW
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
    updateAvailable.value = false
  }

  removeListener = useEventListener(window, 'swUpdated', setUpdateAvailble)

  useEventListener(navigator.serviceWorker, 'controllerchange', () => {
    if (!reloading) {
      reloading = true
      // Here the actual reload of the page occurs
      window.location.reload()
    }
  })

  return {
    updateAvailable,
    update,
  }
}

export default useServiceWorker
